import React from "react";
import { useIntl } from "react-intl";

import { canonicalUsageModel, historicalWan26ModelOf, isAmbiguousWanUsageModel } from "./aiUsageModels";

interface AiUsageModelLabelProps {
  provider: string;
  model: string;
  videoDuration?: number | null;
}

const AiUsageModelLabel: React.FC<AiUsageModelLabelProps> = ({ provider, model, videoDuration }) => {
  const intl = useIntl();
  const canonical = canonicalUsageModel(provider, model, videoDuration);
  const title = historicalWan26ModelOf(provider, model, videoDuration)
    ? intl.formatMessage({ id: "megen.cost.historicalWan26Model" }, { model, target: canonical, seconds: videoDuration })
    : model && canonical !== model
      ? intl.formatMessage({ id: "megen.cost.originalModel" }, { model })
      : isAmbiguousWanUsageModel(provider, model, videoDuration)
        ? intl.formatMessage({ id: "megen.cost.ambiguousModel" }, { model })
        : undefined;
  return <span title={title}>{canonical || "-"}</span>;
};

export default AiUsageModelLabel;
